/* import __COLOCATED_TEMPLATE__ from './phone-details-call-section.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import type { CallRecording } from 'embercom/objects/inbox/call-recording';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface PhoneDetailsCallSectionSignature {
  Args: {
    recording: CallRecording;
    recordingNumber: number;
    onPlay: () => void;
    additionalCallDetailsLoaded: boolean;
    callId: number | string;
    accordion?: $TSFixMe;
  };
  Element: HTMLDivElement;
}

export default class PhoneDetailsCallSection extends Component<PhoneDetailsCallSectionSignature> {
  @service declare intl: IntlService;

  get recordingSectionId(): string {
    return this.recordingHeadingKey;
  }

  get recordingNumberText(): string {
    return ((this.args.recordingNumber ?? 0) + 1).toString();
  }

  get isFinRecording(): boolean {
    return this.args.recording.recordingType === 'fin_voice';
  }

  get recordingHeadingKey(): string {
    let translationKey =
      this.args.recording.recordingType === 'fin_voice'
        ? 'inbox.phone-details-sidebar.fin-recording-heading'
        : 'inbox.phone-details-sidebar.main-recording-heading';

    return this.intl.t(translationKey, { number: this.recordingNumberText });
  }

  get formattedDuration() {
    return this.intl.formatDuration(this.args.recording.duration ?? 0).split(' ')[0];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::PhoneDetailsCallSection': typeof PhoneDetailsCallSection;
    'inbox2/phone-details-call-section': typeof PhoneDetailsCallSection;
  }
}
